import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloCheckboxIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props}>
    <path
      d='M18 5L7.33333 15L2 10'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </EloBaseIcon>
)
